import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class LocationOverviewManageEventLogController extends Controller {
  queryParams = ['page', 'search', 'sort', 'locationId'];

  @tracked page = 1;
  @tracked search = '';
  @tracked sort = 'event_timestamp:desc';
  @tracked locationId: number | null = null;

  @action
  changeSearch(search: string): void {
    this.search = search;
    this.page = 1; // Reset to first page
  }

  @action
  changeSort(sort: string): void {
    this.sort = sort;
    this.page = 1; // Reset to first page
  }

  @action
  changeLocation(locationId: number | null): void {
    this.locationId = locationId;
    this.page = 1; // Reset to first page
  }
}
